module.exports = require("./src/angulartics.js");
module.exports = require("./src/angulartics-adobe.js");
module.exports = require("./src/angulartics-chartbeat.js");
module.exports = require("./src/angulartics-cnzz.js");
module.exports = require("./src/angulartics-flurry.js");
module.exports = require("./src/angulartics-ga-cordova.js");
module.exports = require("./src/angulartics-ga.js");
module.exports = require("./src/angulartics-gtm.js");
module.exports = require("./src/angulartics-kissmetrics.js");
module.exports = require("./src/angulartics-mixpanel.js");
module.exports = require("./src/angulartics-piwik.js");
module.exports = require("./src/angulartics-scroll.js");
module.exports = require("./src/angulartics-segmentio.js");
module.exports = require("./src/angulartics-splunk.js");
module.exports = require("./src/angulartics-woopra.js");
module.exports = require("./src/angulartics-marketo.js");
module.exports = require("./src/angulartics-intercom.js");


//////////////////
// WEBPACK FOOTER
// angulartics (bower component)
// module id = 40
// module chunks = 0